import { Monitor, Sun, Moon, type LucideIcon } from "lucide-react";

export type Theme = "dark" | "light" | "system";

export type ThemeProviderState = {
  theme: Theme;
  setTheme: (theme: Theme) => void;
};

/** The pickable themes, in the order the switcher shows them. */
export const THEME_OPTIONS: { value: Theme; icon: LucideIcon; labelKey: string }[] = [
  { value: "system", icon: Monitor, labelKey: "theme.system" },
  { value: "light", icon: Sun, labelKey: "theme.light" },
  { value: "dark", icon: Moon, labelKey: "theme.dark" },
];
